/**
 * Formatter for Random Gift Picker
 * This lives on the Global Window Object as randonPrize, and is setup with a self-loading function.
 *
 * Requires jQuery to work
 *
 * Naming:
 * _[name] = Class scoped variables
 * camelCase names are used for all other functions, properties and variables
 */
/* eslint complexity: 0 */
window.randomPrize = (function ($, generic) {
  // The return API
  var api = {};
  // Listener for the game ready event
  var _gameReady = $.Deferred();
  // All the information about the offer is stored in this object
  var _offers = {
    offerArray: [],
    winningOffer: false,
    winningProduct: false,
    winningCategory: false,
    winningSku: false,
    offerProbability: {},
    offersProducts: {},
    availableOffers: {}
  };
  var _filters = {
    skuFilter: ['INVENTORY_STATUS', 'SKU_ID', 'PRODUCT_CODE'],
    productFilter: ['IMAGE_LARGE'],
    categoryFilter: [],
    offerFilter: []
  };
  var _options = {
    continuePlayOnceWon: true, // allow the game to continue once the user has one
    stopGameUntilNextDayOnceWon: true, // stop the game until next day once offer added to bag
    stopGameFor24HoursOnceWon: false, // stop the game for 24h once offer added to bag
    useProductImages: true, // use product images if they are available
    showUnavailableOnOfferApplied: false
  };
  var _nodes = {
    wrapper: $('.js-game-formatter-wrapper'),
    popup: $('.js-game-formatter__popup-box'),
    winBox: $('.js-win-box'),
    gameTries: $('.js-game-tries-numbers'), // Catches all the instances of this
    errorBox: $('.js-game-formatter__error'),
    landing: $('.js-game-formatter__landing'),
    gameOver: $('.js-game-formatter__over'),
    unavailable: $('.js-game-formatter__unavailable'),
    loading: $('.js-game-formatter__loading'),
    offerCodes: $('.js-offer_codes').val(),
    errorLoadOfferMessage: $('.js-error_load_offer_message').val(),
    errorApplyOfferMessage: $('.js-error_apply_offer_message').val(),
    errorUnavailableOfferMessage: $('.js-error_unavailable_offer_message').val(),
    winChance: parseInt($('.js-win_chance').val()) || 50,
    numberOfTries: parseInt($('.js-no_of_tries').val()) || 3,
    customImageFolder: $('.js-popup_custom_image_folder').val() || '',
    errors: {
      noSearchTerm: $('ul.js-error_messages li.js-no-search-term')
    }
  };
  var _cartResult = {};
  var _prizeData = {};

  // --- PRIVATE

  /**
   * Check the probability of the offers
   *
   * @param {object} offers - An array of offers, that should have a probability property
   * @param {number} totalProbability - The total probabilty of all the items
   * @returns {object} - the result of the offers
   */
  function checkProbability(offers, totalProbability) {
    if (!offers) {
      return;
    }
    // Set the default to 100
    totalProbability = totalProbability || 100;
    var returnObj = {
      offers: [],
      probabilities: {}
    };

    $.each(offers, function (key, value) {
      var offer_and_probability = value.split ? value.split(':') : value;
      var probability = _offers.availableOffers[value].probability || 100 / Object.keys(offers).length;

      // Returns Object as it's an [Array] Object from a string split
      if (typeof offer_and_probability === 'object') {
        // Checks that there are items in the object
        if (Object.keys(offer_and_probability).length > 1) {
          // The offer works
          returnObj.offers[key] = offer_and_probability[0];
          returnObj.probabilities[offer_and_probability[0]] = offer_and_probability[1];
        } else {
          // It's a single offer
          returnObj.offers[key] = offer_and_probability[0];
          returnObj.probabilities[offer_and_probability[0]] = (probability / totalProbability) * 100;
        }
      } else {
        // should never hit here as offers should always be an object [array]
        returnObj.offers[key] = key;
        // Add the probability default as a backup
        returnObj.probabilities[offer_and_probability[0]] = (probability / totalProbability) * 100;
      }
    });

    return returnObj;
  }

  /**
   * Checks the probability that each item will have
   *
   * @param {array} offers - the list of offers you want the probability from
   * @returns {number} total probility
   */
  function checkTotalProbability(offers) {
    var totalProbability = 0;

    $.each(offers, function (key, value) {
      if (value === null) { // check offer exists
        delete offers[key]; // remove from object
      } else {
        // check all offers are active
        if (value.timing !== 'active') {
          delete offers[key]; // remove from object
        } else {
          value.probability = value.probability || 100 / Object.keys(offers).length;
          totalProbability += value.probability;
        }
      }
    });

    return totalProbability;
  }

  /**
   * Used to simply return a random number within a range
   *
   * @param {number} numberStart - the number to start on
   * @param {number} numberRange - the number to go upto
   * @returns {number} the random number generated
   */
  function getRandomNumber(numberStart, numberRange) {
    return Math.floor((Math.random() * numberRange) + numberStart);
  }

  // --- PUBLIC

  /**
   * Set 24 hour cookie once won
   *
   * @return {false} - none
   */
  api.set24HourCookie = function () {
    var date = new Date();

    date.setTime(date.getTime() + (24 * 60 * 60 + 1) * 1000);
    document.cookie = 'twenty_four=1;expires=' + date.toGMTString() + ';';
  };

  /**
   * A helper class for adding a Cookie to the users browser
   *
   * @param {string} name - the name of the cookie you want to add
   * @return {false} none
   */
  api.getCookie = function (name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');

    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
  };

  /**
   * Get number of tries cookie
   *
   * @returns {bool} - result of the Game Tries Cookie
   */
  api.getNumberOfTriesCookie = function () {
    return api.getCookie('game_tries');
  };

  /**
   * Set number of tries cookie, this is calculated assending
   *
   * @returns {false} none
   */
  api.setNumberOfTriesCookie = function () {
    var date = new Date();

    date.setTime(date.getTime() + (24 * 60 * 60 + 1) * 1000);
    if (!api.getNumberOfTriesCookie()) {
      document.cookie = 'game_tries=1;expires=' + date.toGMTString() + ';';
    } else {
      var cookieCalc = parseInt(api.getNumberOfTriesCookie()) + 1;

      document.cookie = 'game_tries = ' + cookieCalc + ';expires=' + date.toGMTString() + ';';
    }
  };

  /**
   * This is where we get the prize before we even start playing the game
   *
   * @returns {string} - Inventory Status of the current Winning Sku
   */
  api.checkInventoryStatus = function () {
    return _offers.winningSku.INVENTORY_STATUS;
  };

  /**
   * This is where we set the prize before we even start playing the game
   *
   * @param {array} offers - list of offers
   * @param {number} probability - the chance of winning
   * @returns {false} none
   */
  api.setPrize = function (offers, probability) {
    var random_num = getRandomNumber(1, 100, true);
    var weight_sum = 0;

    // Reset the winning items
    _offers.winningSku = false;
    _offers.winningProduct = false;

    for (var i = 0; i < offers.length; i++) {
      weight_sum += parseInt(probability[offers[i]]);
      weight_sum = +weight_sum;
      if (random_num <= weight_sum) {
        _offers.winningOffer = _offers.availableOffers[offers[i]];
        // once we have the offer we can now get the prize if it is a sku related product
        if (typeof _offers.offersProducts.skus[_offers.winningOffer.offer_code] === 'object') {
          // if a product type offer we should always have a sku as the backend should always return this
          if (_offers.offersProducts.skus[_offers.winningOffer.offer_code] && _offers.offersProducts.skus[_offers.winningOffer.offer_code].length) {
            // backend should only return valid skus, ie shoppable but lets do a check just in case
            for (var n = 0; n < _offers.offersProducts.skus[_offers.winningOffer.offer_code].length; n++) {
              // Set the products
              _offers.winningSku = _offers.offersProducts.skus[_offers.winningOffer.offer_code][n];
              // Set to a new product
              _offers.winningProduct = _offers.offersProducts.products[_offers.winningSku.PRODUCT_ID];
              // Check the product is in stock
              if (api.checkInventoryStatus() === 1 || api.checkInventoryStatus() === 6) {
                break;
              } else {
                _offers.winningSku = false;
                _offers.winningProduct = false;
              }
            }
            if (!_offers.winningSku && !_offers.winningProduct) {
              api.setPrize(_offers.offerArray, _offers.offerProbability);
            }
          } else if (_offers.offersProducts.products[_offers.winningOffer.offer_code] && _offers.offersProducts.products[_offers.winningOffer.offer_code].length) {
            // a product but should never hit here
          } else {
            // probably a category but should never hit here
          }
        }
        break;
      }
    }
  };

  /**
   * Set a new prize for the offer
   *
   * @returns {bool} false
   */
  api.setNewPrize = function () {
    api.setPrize(_offers.offerArray, _offers.offerProbability);
  };

  /*
   * Set winning offer cookie
   */
  api.setWinningOfferCookie = function (offer_code) {
    var date = new Date();

    date.setTime(date.getTime() + (24 * 60 * 60 + 1) * 1000);
    document.cookie = 'winning_offer=' + offer_code + ';expires=' + date.toGMTString() + ';';
  };

  /**
   * Get 24 hour cookie
   *
   * @return {bool} - result of setting the Cookie
   */
  api.get24HourCookie = function () {
    return api.getCookie('twenty_four');
  };

  /*
   * Get winning offer cookie
   */
  api.getWinningOfferCookie = function () {
    var winning_offer = api.getCookie('winning_offer');

    return winning_offer ? winning_offer : '';
  };

  /*
   * Get next day cookie
   */
  api.getNextDayCookie = function () {
    return api.getCookie('game_next_day') ? 1 : 0;
  };

  /*
   * Set next day cookie
   */
  api.setNextDayCookie = function () {
    var date = new Date();

    date.setHours(24, 0, 0, 0);
    document.cookie = 'game_next_day=1;expires=' + date.toGMTString() + ';';
  };

  /**
   * Get the number of tries left
   *
   * @returns {number} - number of tries
   */
  api.getNumberOfTries = function () {
    return api.getNumberOfTriesCookie() || _nodes.numberOfTries;
  };

  /**
   * Get the number of tries left
   *
   * @returns {number} - number of tries
   */
  api.getMaxNumberOfTries = function () {
    return _nodes.numberOfTries;
  };

  /**
   * This is where we get the prize before we even start playing the game
   *
   * @returns {object} - a copy of the _prizeData object
   */
  api.getPrize = function () {
    // do we have a sku as a prize?
    if (typeof _offers.winningSku === 'object') {
      $.each(_filters.skuFilter, function (key, value) {
        _prizeData[value] = _offers.winningSku[value] ? _offers.winningSku[value] : '';
      });
      $.each(_filters.productFilter, function (key, value) {
        _prizeData[value] = _offers.winningProduct[value] ? _offers.winningProduct[value] : '';
      });
      $.each(_filters.categoryFilter, function (key, value) {
        _prizeData[value] = _offers.winningCategory[value] ? _offers.winningCategory[value] : '';
      });
      $.each(_filters.offerFilter, function (key, value) {
        _prizeData[value] = _offers.winningOffer[value] ? _offers.winningOffer[value] : '';
      });
    }

    return _prizeData;
  };

  /**
   * Get the chance of winning per round
   *
   * @returns {number} win_change reference
   */
  api.getWinChance = function () {
    return _nodes.winChance;
  };

  /**
   * Show the unavailable message
   *
   * @returns {false} none
   */
  api.getUnavailableMessage = function () {
    _nodes.popup.removeClass('hidden');
    _nodes.unavailable.removeClass('hidden');

    _nodes.wrapper.addClass('game-unavailable');
    $(document).trigger('randomPrize.game-unavailable');
    if ($(window).width() < 990) {
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
    }
  };

  api.getGameOverMessage = function () {
    _nodes.popup.removeClass('hidden');
    _nodes.gameOver.removeClass('hidden');

    _nodes.wrapper.addClass('game-over');

    if ($(window).width() < 990) {
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
    }
  };

  /**
   * Show the Error message
   *
   * @param {string} errorMsg - the error message to show with the Error Box
   * @returns {false} none
   */
  api.getErrorMessage = function (errorMsg) {
    _nodes.loading.addClass('hidden');
    _nodes.popup.removeClass('hidden');
    _nodes.errorBox.removeClass('hidden');

    _nodes.wrapper.addClass('game-error');

    if (errorMsg) {
      _nodes.errorBox.find('.error-message').removeClass('hidden').text(errorMsg);
    }

    if ($(window).width() < 990) {
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
    }
  };

  /**
   * Show the loading page whlst RPC call gets data
   *
   * @returns {false} none
   */
  api.getLoading = function () {
    _nodes.loading.removeClass('hidden');
  };

  /**
   * Stop the loading page
   *
   * @returns {false} none
   */
  api.stopLoading = function () {
    _nodes.loading.addClass('hidden');
  };

  /**
   * Returns a JSON Object with the Winning Information
   *
   * @returns {Object} winInfo - Winning information in a Object Form
   */
  api.getWinningOffer = function () {
    // There is no offer to return to the user
    if (!_offers.winningOffer) {
      return {
        valid: false,
        error: 'no_offer'
      };
    }

    // Does the offer have a SKU?
    // If it does lets grab a product
    // Pick the first match for the product
    var winningProduct = _offers.winningProduct;
    var winningConfirmMessage = String(_offers.winningOffer.confirm_message).replace('::skuname::', winningProduct ? winningProduct.PROD_RGN_NAME : '');

    // Return the Offer Object
    return {
      // Is the offer Valid or not
      valid: _offers.winningOffer !== false,
      // Add the winning offer object
      winningOffer: _offers.winningOffer,
      // Add the winning sku object
      winningSku: _offers.winningSku,
      // Add the winning product object
      winningProduct: _offers.winningProduct,
      // Winning title,
      title: '',
      // Description for the win message
      description: _offers.winningOffer.description,
      // Confirm message
      confirmMessage: winningConfirmMessage,
      // The image assosiated with this winning offer
      image: winningProduct ? winningProduct.IMAGE_LARGE : _nodes.customImageFolder + _offers.winningOffer.image,
      // Does the user have the ability to play again
      playAgain: parseInt(api.getNumberOfTriesCookie()) < _nodes.numberOfTries
    };
  };

  /**
   * Validate that the game is ready to be played
   *
   * @return {bool} - is the Game ready
   */
  api.isGameValidforPlay = function () {
    var areTriesLeft = api.getNumberOfTriesCookie() <= _nodes.numberOfTries;
    var haveTheyWon = _options.continuePlayOnceWon || (!_options.continuePlayOnceWon && !api.has_won);
    var isGameActive = !_options.stopGameFor24HoursOnceWon; // Check we don't have this option enabled

    return areTriesLeft && haveTheyWon && isGameActive;
  };

  /**
   * This is where we get the prize before we even start playing the game
   *
   * @returns {bool} iShoppable reference
   */
  api.isShoppable = function () {
    return _offers.winningSku.isShoppable;
  };

  /**
   * Detects if the user has already played the game or not
   *
   * @returns {bool} true if played
   */
  api.isAlreadyPlayed = function () {
    var currentOffer = api.getWinningOffer() || {
      'valid': false
    };

    return currentOffer.valid && api.getWinningOfferCookie() && api.get24HourCookie() ? true : false;
  };

  /*
   * Delete winning offer cookie
   */
  api.deleteWinningOfferCookie = function () {
    var date = new Date();

    date.setTime(date.getTime() - (24 * 60 * 60 + 1) * 1000);
    document.cookie = 'winning_offer=;expires=' + date.toGMTString() + ';';
  };

  /*
   * Delete next day cookie
   */
  api.deleteNextDayCookie = function () {
    var date = new Date();

    date.setTime(date.getTime() - (24 * 60 * 60 + 1) * 1000);
    document.cookie = 'game_next_day=1;expires=' + date.toGMTString() + ';';
  };

  /*
   * Delete 24h cookie
   */
  api.delete24HourCookie = function () {
    var date = new Date();

    date.setTime(date.getTime() - (24 * 60 * 60 + 1) * 1000);
    document.cookie = 'twenty_four=1;expires=' + date.toGMTString() + ';';
  };

  /**
   * Hides any popup box that is currently showing
   *
   * @returns {false} none
   */
  api.hidePopup = function () {
    _nodes.popup.addClass('hidden');
    _nodes.errorBox.addClass('hidden');
    _nodes.unavailable.addClass('hidden');
  },

  /**
   * This is where we get all the offers, set the probability (if set in Drupal) and set the winning price
   *
   * @return {false} none
   */
  api.parseOfferAndProbability = function () {
    _offers.offerArray = _nodes.offerCodes.split(',');

    var params = [
      {
        'offers': _offers.offerArray,
        'get_products': 1,
        'get_transaction': 1,
        'suppress_message': 1
      }
    ];
    var offersRedeemed = generic.cookie('APPLIED_OFFERS') || '';
    var tries = api.getNumberOfTriesCookie() - _nodes.numberOfTries;

    generic.jsonrpc.fetch({
      method: 'offers.getOffersRpcData',
      params: params,
      onSuccess: function (response) {
        // Pre defines
        var responseValues = response.getValue();

        if (responseValues) {
          _offers.availableOffers = Object.keys(responseValues.offers || {}).length ? responseValues.offers : false;
          _offers.offersProducts = Object.keys(responseValues.offersProducts || {}).length ? responseValues.offersProducts : false;
          _cartResult = Object.keys(responseValues.transaction || {}).length ? responseValues.transaction : false;
        }

        if (Object.keys(_offers.availableOffers).length > 0) {
          // Grab the probability that each item in the array will show
          var probabilty = checkProbability(_offers.offerArray, checkTotalProbability(_offers.availableOffers));

          // Assign the the globals
          _offers.offerArray = probabilty.offers;
          _offers.offerProbability = probabilty.probabilities;
          $.each(_offers.offerArray, function (key, value) {
            if ((offersRedeemed.indexOf(value) > -1) && (tries <= 0)) {
              api.getUnavailableMessage();

              return false;
            }
          });
          if (api.getWinningOfferCookie() && api.get24HourCookie()) {
            var offerCodeWon = api.getWinningOfferCookie();

            _offers.winningOffer = _offers.availableOffers[offerCodeWon];
          } else {
            api.setPrize(_offers.offerArray, _offers.offerProbability);
            api.getPrize();
          }
          // now we can do some animation stuff, play a game etc
          _gameReady.resolve();
        } else {
          api.getGameOverMessage();
        }
      },
      onFailure: function () {
        api.getErrorMessage(_nodes.errorLoadOfferMessage);
      }
    });
  };

  /**
   * User has the offer already in their cart
   *
   * @returns {boolean} true if the offer is in the cart
   */
  api.hasOfferInCart = function () {
    var winningOfferInfo = api.getWinningOffer();

    return winningOfferInfo.valid && $.inArray(winningOfferInfo.winningOffer.offer_code, _cartResult.offerCodes) >= 0;
  };

  /**
   * Show the Winning Message (Pop Up), this should only be used as legacy
   *
   * @returns {bool} false
   */
  api.showWinMessage = function () {
    // Show the random prize win box if required
    _nodes.winBox.removeClass('hidden');
  };

  /**
   * Apply the current Winning Offer via the JSONRPC Call
   *
   * @param {function} onSuccess (optional) - An on Sucess Function
   * @param {function} onFail (optional) - An on Fail Function
   * @returns {bool} false
   */
  api.applyOffer = function (onSuccess, onFail) {
    // Assign the offer code
    var offer_code = _offers.winningOffer.offer_code;
    var offer_value, offer_params;

    if (_offers.winningProduct) {
      offer_value = _offers.winningProduct.product_ID;
      offer_params = [
        {
          offer_code: offer_code,
          benefits: {
            ChoiceOfSkus: {
              choices: [_offers.winningProduct.product_ID]
            }
          }
        }
      ];
    } else {
      offer_value = _offers.winningOffer.benefits[0].value;
      offer_params = [
        {
          offer_code: offer_code,
          benefits: {
            PercentDiscount: {
              class: offer_value
            }
          }
        }
      ];
    }

    // Call offers.apply via RPC
    generic.jsonrpc.fetch({
      method: 'offers.apply',
      params: offer_params,
      onSuccess: function (res) {
        // Success
        if (typeof onSuccess === 'function') {
          onSuccess(res);
        }
      },
      onFailure: function (error) {
        if (typeof onFail === 'function') {
          onFail(error);
        } else {
          api.getErrorMessage(_nodes.errorApplyOfferMessage);
        }
      }
    });
  };

  /**
   * Initialise the game, this needs to be called for the game to begin
   *
   * @param {function} onComplete (optional) - a function called when the init has completed
   * @return {bool} true
   */
  api.init = function (onComplete) {
    api.parseOfferAndProbability();
    $.when(_gameReady).then(function () {
      // setup an object to return to the onComplete
      var returnObj = {
        api: api,
        isValid: api.isGameValidforPlay(),
        numberOfTries: api.getNumberOfTries()
      };

      // user has already won something - display their prize
      if ($.inArray(_offers.winningOffer.offer_code, _cartResult.offerCodes) >= 0) {
        // Just show that they can't play again
        api.getUnavailableMessage();
        returnObj.error = true;
        returnObj.errorMessage = _nodes.errorUnavailableOfferMessage;
      } else {
        returnObj.error = false;
      }
      if (typeof onComplete === 'function') {
        onComplete(returnObj);
      }
    });

    return true;
  };

  // @return the API Object
  return api;
})(window.jQuery, window.generic || {});
